import script from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MainHeader.vue?vue&type=style&index=0&id=223a3124&lang=scss"

const __exports__ = script;

export default __exports__